import React, { useState } from 'react';
import { Button, Collapse } from 'react-bootstrap';

const CollapseButton = ({ children, expandLabel, collapeLabel }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <Button variant="secondary" onClick={() => setIsOpen(!isOpen)}>
                {isOpen
                    ? collapeLabel ?? 'Collapse'
                    : expandLabel ?? 'Expand'}
            </Button>
            <Collapse in={isOpen}>
                <div>
                    {children}
                </div>
            </Collapse>
        </>
    );
};

export default CollapseButton;